/** Hvad der skal registreres (blanketens overordnede flow). */
export const WhatToRegister = {
  Creation: "creation",
  Change: "change",
  Termination: "termination",
} as const;
export type WhatToRegisterChoice =
  (typeof WhatToRegister)[keyof typeof WhatToRegister];
export type WhatToRegister = WhatToRegisterChoice | "";

/** Virksomhedstype i blanketten. */
export const CompanyType = {
  Enkeltmandsvirksomhed: "enkeltmandsvirksomhed",
  Interessentskab: "interessentskab",
  Advokatselskab: "advokatselskab",
} as const;
export type CompanyTypeChoice = (typeof CompanyType)[keyof typeof CompanyType];
export type CompanyType = CompanyTypeChoice | "";

export const JaNej = {
  Ja: "Ja",
  Nej: "Nej",
} as const;
export type JaNejChoice = (typeof JaNej)[keyof typeof JaNej];
export type JaNej = JaNejChoice | "";

/**
 * The values are the Danish labels themselves: they are sent to the API as
 * strings and printed verbatim in the PDF the department receives.
 */
export const InvoiceTarget = {
  EBoks: "E-boks",
  Mail: "Mail",
  Brev: "Brev",
  EAN: "EAN",
} as const;
export type InvoiceTargetChoice =
  (typeof InvoiceTarget)[keyof typeof InvoiceTarget];
export type InvoiceTarget = InvoiceTargetChoice | "";

export const CompanyForm = {
  AS: "A/S",
  ApS: "ApS",
  PS: "P/S",
} as const;
export type CompanyFormChoice = (typeof CompanyForm)[keyof typeof CompanyForm];
export type CompanyForm = CompanyFormChoice | "";

export const ParticipantType = {
  Person: "Person",
  Company: "Selskab",
} as const;
export type ParticipantTypeChoice =
  (typeof ParticipantType)[keyof typeof ParticipantType];
export type ParticipantType = ParticipantTypeChoice | "";

/** Årsag til udtræden for fysiske personer ved ændringsblanket. */
export const WithdrawalReason = {
  ContinuesAsLawyer: "FortsætterSomAdvokat",
  Deposits: "Deponerer",
} as const;
export type WithdrawalReasonChoice =
  (typeof WithdrawalReason)[keyof typeof WithdrawalReason];
export type WithdrawalReason = WithdrawalReasonChoice | "";

/** Ændringstype for interessentskab. */
export const ChangeInteressentskabKind = {
  InteressentInd: "Interessent indtræder",
  InteressentUd: "Interessent udtræder",
  InteressentBegge: "Begge dele",
} as const;
export type ChangeInteressentskabKindChoice =
  (typeof ChangeInteressentskabKind)[keyof typeof ChangeInteressentskabKind];
export type ChangeInteressentskabKind = ChangeInteressentskabKindChoice | "";

/** Retning for en interessent ved både ind- og udtræden. */
export const InterestPartyChangeDirection = {
  Enters: "Indtræder",
  Leaves: "Udtræder",
} as const;
export type InterestPartyChangeDirectionChoice =
  (typeof InterestPartyChangeDirection)[keyof typeof InterestPartyChangeDirection];
export type InterestPartyChangeDirection =
  InterestPartyChangeDirectionChoice | "";

export const LawyerOrLawFirmStatus = {
  Ja: "Ja",
  IkkeAdvokatselskab: "IkkeAdvokatselskab",
  IkkeAdvokat: "IkkeAdvokat",
} as const;
export type LawyerOrLawFirmStatusChoice =
  (typeof LawyerOrLawFirmStatus)[keyof typeof LawyerOrLawFirmStatus];
export type LawyerOrLawFirmStatus = LawyerOrLawFirmStatusChoice | "";

/** Ændringstype for advokatselskab. */
export const ChangeAdvokatselskabKind = {
  PartnerInd: "En/flere selskabsdeltager(e) indtræder",
  PartnerUd: "En/flere selskabsdeltager(e) udtræder",
  PartnerBegge: "En/flere selskabsdeltager(e) indtræder og udtræder",
} as const;
export type ChangeAdvokatselskabKindChoice =
  (typeof ChangeAdvokatselskabKind)[keyof typeof ChangeAdvokatselskabKind];
export type ChangeAdvokatselskabKind = ChangeAdvokatselskabKindChoice | "";
